import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9krr246qu7: FaireBrandEntity = {
  token: "b_9krr246qu7",
  type: "brand",
  name: "Auraquise",
  avatarUrl:
    "https://cdn.faire.com/fastly/2ce5553afc130f4eae18408301a48361863adc3a9e8c086496f67c402ceca320.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1917544833762b40df98eb6407783a56f0595e67236b57b732864da8835d351.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2ce5553afc130f4eae18408301a48361863adc3a9e8c086496f67c402ceca320.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1917544833762b40df98eb6407783a56f0595e67236b57b732864da8835d351.png",
  location: "Lake Forest, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 100,
  isTopShop: true,
  isInsider: false,
  description:
    "At Auraquise, we believe every child deserves to shine. Founded with a passion for creativity and quality, Auraquise creates unique children’s clothing that captures the magic of childhood. Each piece is thoughtfully designed to blend playful originality with practical comfort, ensuring your little ones feel confident and free to explore the world.\n\nOur commitment to excellence goes beyond design. With fast shipping, exceptional quality, and affordable pricing, Auraquise makes it easy for parents to dress their children in style without compromise.\n\nJoin the Auraquise family, where every outfit tells a story, and every child’s light shines a little brighter.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:06.808Z",
    importedBy: "entity-db-cli",
  },
};
